module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-Light.211fd9d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/sourceSansPro/SourceSansPro-Light.woff
// module id = uZub
// module chunks = 88